import React, { Component } from "react";
//import InputRange from "../../../components/Common/inputRange";
import Datetime from "react-datetime";
import Input from "../../../components/Common/input";
import { InputGroup } from "react-bootstrap";
//import Select from "../../../components/Common/select";

import { Col, Row } from "react-bootstrap";
class RekapQcSearch extends Component {
  state = {};
  render() {
    const {
      handleChangeDate,
      handleChange,
      search,
      handleSubmitSearch,
    } = this.props;
    return (
      <Row>
        <Col md={3}>
          <Input
            onChange={handleChange}
            value={search.group}
            name="group"
            label="Group"
          />
        </Col>
        <Col md={8}>
          <div className="form-group">
            <label>Stuffing Date</label>
            <InputGroup>
              <Datetime
                timeFormat={false}
                dateFormat={"DD-MM-YYYY"}
                inputProps={{ placeholder: "Dari" }}
                value={
                  search.dateFrom ? new Date(search.dateFrom) : ""
                }
                onChange={(e) => handleChangeDate(e, "dateFrom")}
              />
              <InputGroup.Addon>
                <i className="fa fa-minus" />
              </InputGroup.Addon>
              <Datetime
                timeFormat={false}
                dateFormat={"DD-MM-YYYY"}
                inputProps={{ placeholder: "Sampai" }}
                value={search.dateTo ? new Date(search.dateTo) : ""}
                onChange={(e) => handleChangeDate(e, "dateTo")}
              />
            </InputGroup>
          </div>
        </Col>
        <Col md={2} style={{ paddingTop: "25px" }}>
          <button
            className="btn btn-fill btn-success"
            onClick={handleSubmitSearch}
          >
            Search
          </button>
        </Col>
      </Row>
    );
  }
}

export default RekapQcSearch;



// WEBPACK FOOTER //
// ./src/views/qc/report/rekapQcSearch.jsx